"use strict";

var _regeneratorRuntime = require("/home/gitlab-runner/builds/o6jZzivs/0/root/rf-kiln/node_modules/@babel/runtime/regenerator");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.replaceColorSvg = exports.downloadSvgImage = exports.loadImage = void 0;

var Utils_1 = require("../../Utils");

function loadImage(source) {
  return new Promise(function (resolve, reject) {
    if (!source) {
      reject("Error tsParticles - No image.src");
      return;
    }

    var image = {
      source: source,
      type: source.substr(source.length - 3)
    };
    var img = new Image();
    img.addEventListener("load", function () {
      image.element = img;
      resolve(image);
    });
    img.addEventListener("error", function () {
      reject("Error tsParticles - loading image: ".concat(source));
    });
    img.src = source;
  });
}

exports.loadImage = loadImage;

function downloadSvgImage(source) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var image, response;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (source) {
              _context.next = 2;
              break;
            }

            throw new Error("Error tsParticles - No image.src");

          case 2:
            image = {
              source: source,
              type: source.substr(source.length - 3)
            };

            if (!(image.type !== "svg")) {
              _context.next = 5;
              break;
            }

            return _context.abrupt("return", loadImage(source));

          case 5:
            _context.next = 7;
            return fetch(image.source);

          case 7:
            response = _context.sent;

            if (response.ok) {
              _context.next = 10;
              break;
            }

            throw new Error("Error tsParticles - Image not found");

          case 10:
            _context.next = 12;
            return response.text();

          case 12:
            image.svgData = _context.sent;
            return _context.abrupt("return", image);

          case 14:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
}

exports.downloadSvgImage = downloadSvgImage;

function replaceColorSvg(imageShape, color, opacity) {
  var svgData = imageShape.svgData;

  if (!svgData) {
    return "";
  }

  if (svgData.includes("fill")) {
    var currentColor = /(#(?:[0-9a-f]{2}){2,4}|(#[0-9a-f]{3})|(rgb|hsl)a?\((-?\d+%?[,\s]+){2,3}\s*[\d.]+%?\))|currentcolor/gi;
    return svgData.replace(currentColor, function () {
      return Utils_1.getStyleFromHsl(color, opacity);
    });
  }

  var preFillIndex = svgData.indexOf(">");
  return "".concat(svgData.substring(0, preFillIndex), " fill=\"").concat(Utils_1.getStyleFromHsl(color, opacity), "\"").concat(svgData.substring(preFillIndex));
}

exports.replaceColorSvg = replaceColorSvg;